export const isOneOf = (value: string, options: string[]) => options.includes(value);
